/**
 * @author lhu
 * @description 课堂助手-考试查看
 * @Date 2020/4/22
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateCofig, templateConfig} from './columns'
import ExamResultCharts from './examResultCharts'
import {modelUtils} from '@/utils'
import {component_tool, framework_tool, utils_tool} from '@/tool'
import {WizModalUserIdentityShow} from '@/containers/common';
import ClassStudentAideInfo from './../classStudentAide/classStudentAideInfo'

let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport, WizCard, WizTabs, WizSpin, WizModal} = component_tool;
let {Session} = utils_tool;

class ClassStudentExamList extends WizContainer {

  componentName = 'ClassStudentExamList';

  constructor(props) {
    super(props);
    const { history } = props;
    this.state = {
      selectedClassResultRows: [],//选择的学员
      showUserPersonInfoVisible: false,
      classStudentExamInfo:{}
    };

    if (history.location &&  history.location.pathname === "/face/classList/classAideDetail/classStudentExamList") {
      if (history.location.record) {
        this.classStudentExamRecord = history.location.record
        Session.set('classStudentExamRecord', this.classStudentExamRecord);
      } else {
        this.classStudentExamRecord = Session.get('classStudentExamRecord') || {}
      }
    }

  }

  propsAndStateOnChange = {
  };

  

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key];
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '身份证',
        field: 'idCard',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      
      // {
      //   headerName: '用户属性',
      //   field: 'userTypeName',
      //   width: 15,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: {vertical: 'bottom', horizontal: 'center'},
      //   },
      // },
      // {
      //   headerName: '账号状态',
      //   field: 'userStatusName',
      //   width: 15,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: {vertical: 'bottom', horizontal: 'center'},
      //   },
      // },
      // {
      //   headerName: '阅卷时间',
      //   field: 'examTime',
      //   width: 15,   
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: {vertical: 'bottom', horizontal: 'center'},
      //   },
      // },
      {
        headerName: '组织名称',
        field: 'orgName',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织代码',
        field: 'orgCode',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '在职状态',
        field: 'jobStateName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '是否请假',
        field: 'leaveStateStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '是否参加',
        field: 'isExamName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '成绩',
        field: 'scoreVal',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '通过状态',
        field: 'scoreStateName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      
      
    ]
    if (o['success']) {
      let data = o['data'];
      WizBrowserExport({
        title: '班级考试成绩信息',
        sheetName: '班级考试成绩信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '班级考试成绩信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  /**
   * 获取查看学员班级任职信息
   * @param classResultRecord
   * @private
   */
  _showUserPersonModal = (classStudentExamInfo) => {
    this.setState({
      classStudentExamInfo,
      showUserPersonInfoVisible: true,
    })
    
  };

  _render() {
    const {classStudentExamLoading} = this.props;
    //let record = this.props.location.record;
    const {showUserPersonInfoVisible, classStudentExamInfo} = this.state;
    let classInfoId = this.classStudentExamRecord ? this.classStudentExamRecord.classId : null;
    let examId = this.classStudentExamRecord ? this.classStudentExamRecord.id : null;
    // if (record) {
    //   Session.set('classStudentExamRecord', record);
    // }
    // if (Session.get('classStudentExamRecord')) {
    //   let classStudentExamRecord = Session.get('classStudentExamRecord');
    //   classInfoId = classStudentExamRecord.classId;
    //   examId = classStudentExamRecord.id;
    // }
    let _templateConfig = templateConfig({
      onSelect: (keys, rows) => {
        this.setState({
          selectedClassResultRows: rows,
          selectedRows: rows.length,
          data: new Date().getTime(),
          rows: rows
        });
      },
      _this: this,
      classInfoId,
      _btnLookUserFun: (e) => {
        if (e.record) {
          let classStudentExamInfo = e.record;
          this._showUserPersonModal(classStudentExamInfo);
        }
      }
    });
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: _templateConfig,
      classInfoId,
      examId,
      apiDataFormat: {
        exportClassStudentExam: this._handleFile,
        exportStudentExamByAllIdentity:this._handleFile,
      },
    });
    let lookUserPersonInfoModal = {
      title: '查看已选任职',
      visible: showUserPersonInfoVisible,
      personId: classStudentExamInfo.personId ? classStudentExamInfo.personId : null,
      orgId: classStudentExamInfo.orgId ? classStudentExamInfo.orgId : null,
      positionId: classStudentExamInfo.positionId ? classStudentExamInfo.positionId : null,
      onCancel: (e) => {
        this.setState({
          showUserPersonInfoVisible: false,
          classStudentExamInfo: {},
        });
      },
    };
    return (
      <>
        <WizSpin tip={"加载中"} spinning={classStudentExamLoading }>
          {/* <ExamResultCharts classInfoId={classInfoId} examId={examId}/> */}
          <ClassStudentAideInfo {...this.classStudentExamRecord} />
          <WizCard title={'环节记录'}>
            <WizReduxTemplate  {..._reduxTemplateCofig} />
          </WizCard>
          <WizModalUserIdentityShow {...lookUserPersonInfoModal}/>
        </WizSpin>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {classStudentExam} = state;
  const load = modelUtils.getLoadingState(state, ['classStudentExam']);
  return {
    ...load
  }
};

export default connect(mapStateToProps)(ClassStudentExamList);
